import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend) // charge les fichiers JSON
  .use(LanguageDetector) // détecte la langue du navigateur
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr', // langue par défaut
    debug: false,
    interpolation: {
      escapeValue: false, // pas besoin d'échapper les valeurs dans React
    },
    backend: {
      loadPath: '/locales/{{lng}}.json', // chemin vers tes JSON
    },
  });

export default i18n;
